export default "__VITE_ASSET__CfHLMr_$__"